import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchUser } from '../actions/user';
import TopBar from './Navigation/TopBar';

import { setDefaultTimezone } from '../utils/timezone';

function SessionLayout({
  authenticated = false,
  user,
  children,
  fetchUser: fetchUserAction,
}) {
  useEffect(() => {
    if (authenticated) {
      fetchUserAction(response => setDefaultTimezone(response.data));
    }
  }, []);

  if (authenticated) {
    return (
      <div>
        <TopBar user={user} />
        <div
          style={{ backgroundColor: '#f8fdfd', margin: 0, height: '100%' }}
          className="row w-100 session-content-base"
        >
          <div
            style={{ minHeight: '1024px', paddingTop: '70px' }}
            className="col"
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
  return <div>{children}</div>;
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    user: state.user,
  };
}
SessionLayout.propTypes = {
  fetchUser: PropTypes.func.isRequired,
  authenticated: PropTypes.bool,
  children: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default withRouter(
  connect(mapStateToProps, { fetchUser })(SessionLayout),
);
